'use es6';

import keyMirror from 'react-utils/keyMirror';
import { toArray } from 'underscore';
export const DEFAULT_INITIAL_STEP = 'WELCOME_STEP';
export const DEFAULT_FINISH_STEP = 'done';
export const existingUserSteps = keyMirror({
  [DEFAULT_INITIAL_STEP]: null,
  SHOW_FINDER_STEP: null,
  NEW_FOLDER_STEP: null,
  NEW_FOLDER_CREATED_STEP: null
});
export const newUserSteps = keyMirror({
  [DEFAULT_INITIAL_STEP]: null,
  BUILD_TEMPLATE_STEP: null
});
export const tours = keyMirror({
  EXISTING_USER_IDE: null,
  NEW_USER_IDE: null
});
const existingUserStepsArray = toArray(existingUserSteps);
const newUserStepsArray = toArray(newUserSteps);
export const toursArray = toArray(tours);
export const existingUserTour = {
  steps: existingUserStepsArray
};
export const newUserTour = {
  steps: newUserStepsArray
};